import { render, staticRenderFns } from "./customers-page.vue?vue&type=template&id=212506ac&scoped=true&"
import script from "./customers-page.vue?vue&type=script&lang=js&"
export * from "./customers-page.vue?vue&type=script&lang=js&"
import style0 from "./customers-page.vue?vue&type=style&index=0&id=212506ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212506ac",
  null
  
)

export default component.exports